<template>
    <div class="wlx-site-manager-wrapper wlx-user-manager">
        <header class="site-manager-head-con" style="padding-top: 20px">
            <el-form :inline="true" size="small">
                <el-form-item>
                    <el-input v-model="batchName" placeholder="请输入批次名称" clearable></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" @click="getCertificateBatchList()">搜索</el-button>
                </el-form-item>
            </el-form>
        </header>
        <div style="padding-left: 30px">
            <el-table :data="list">
                <el-table-column label="序号" type="index"></el-table-column>
                <el-table-column prop="batchName" label="批次名称"></el-table-column>
                <el-table-column prop="startDate" label="申请开始时间"></el-table-column>
                <el-table-column prop="endDate" label="申请结束时间"></el-table-column>
                <el-table-column label="操作" width="200px">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="toApplyITC(scope.row.id)">证书申请</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="u-page-con">
                <el-pagination
                    background
                    @size-change="handleSizeChange"
                    @current-change="onPageChangeHandler"
                    :current-page="page"
                    :page-sizes="[10, 20, 50, 100, 200, 500, 1000]"
                    :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCount"
                    v-show="totalCount > 0"
                    style="text-align: center"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            page: 1,
            pageSize: 10,
            totalCount: 0,
            batchName: "",
            dialogFormVisible:false,
            list: []
        };
    },
    components: {
    },
    created() {
        this.getCertificateBatchList();
    },
    watch: {
       
    },
    methods: {
        //查询
        getCertificateBatchList() {
            var that = this;
            this.$http
                .post("/api/XOrg/ItcCertificateBatchMag/getCertificateBatchList", {
                    batchName: this.batchName,
                    PageSize: that.pageSize,
                    page: that.page,
                })
                .then(function (rst) {
                    if (rst.code > 0) {
                        that.list = rst.list;
                        that.page = rst.pagination.pageIndex;
                        that.pageSize = rst.pagination.pageSize;
                        that.totalCount = rst.pagination.totalCount;
                    } else {
                        that.$message.warning(rst.msg);
                    }
                });
        },
        handleSizeChange(val) {
            this.pageSize = val;
            this.getCertificateBatchList();
        },
        onPageChangeHandler(val) {
            this.page = val;
            this.getCertificateBatchList();
        },
        toApplyITC(batchId){
            this.$router.push({
                name: "applyITC",
                params: {
                    batchId: batchId,
                },
            });
        }
    },
};
</script>

<style lang="scss">
.wlx-site-manager-wrapper {
    .demo-form-inline {
        .el-input__inner {
            width: 200px;
        }

        .img_upload {
            width: 500px;
        }
    }
}

.import-stu-info-dialog {
    .el-dialog__header {
        background: #2f7dff;

        .el-dialog__title {
            color: #fff;
        }

        .el-dialog__headerbtn,
        .el-icon-close {
            color: #fff;
        }
    }

    .tip-info-main {
        margin: 20px 30px;
        color: #1a2638;
    }

    .top-tip-con {
        padding-bottom: 25px;
        border-bottom: 1px solid #d8e0e6;
    }

    .tip-article-con {
        margin-left: 10px;
        width: 550px;
        line-height: 1.5;

        .mark-tip {
            color: #e65b72;
        }
    }

    .download-model-con {
        margin-top: 29px;
        text-align: center;
    }

    .download-model-btn {
        background: #ee6c3a;
        border-color: #ee6c3a;
    }

    .import-table-con {
        padding-top: 20px;
        text-align: center;
    }

    .down-load-btn {
        margin-top: 25px;
    }

    .sp-import-num {
        margin-top: 6px;
    }

    .select-impoort-file {
        margin-top: 20px;
    }
}
</style>
